module.exports = __webpack_public_path__ + "img/makeup-active.9da7effc.png";